import type { SubscriptionPlanDto } from '@peach/types/subscriptions/subscription.dto.js';

export const cents = (n: number) => Math.round(n * 100) / 100;

/** What a plan bills every 4 weeks: its price and the Platform fee. */
export const totalOf = (plan: Pick<SubscriptionPlanDto, 'price' | 'platformFee'>) =>
  cents(plan.price + plan.platformFee);

/**
 * The page's one main button, read from where the viewer is: the intro on sale, the
 * intro booked (no button), or a plain Join.
 */
export type MainAction = 'owner' | 'none' | 'intro' | 'join';

export function mainActionFor(viewer: {
  isOwner: boolean;
  subscribed: boolean;
  introBooked: boolean;
  /** Bought the intro, no call booked on it yet: they book the pass, nothing sells over it. */
  introUnbooked: boolean;
  introOnSale: boolean;
}): MainAction {
  if (viewer.isOwner) return 'owner';
  if (viewer.subscribed || viewer.introBooked || viewer.introUnbooked) return 'none';
  return viewer.introOnSale ? 'intro' : 'join';
}
